import { fetchApi } from "../../services/fetchApi";
import { useQuery } from "@tanstack/react-query";

export const useGetOffrePEPart = (ParticulierID: number | undefined) => {
  const promise = () => fetchApi("/api/offre_p_es", { method: "get", query: { Particulier: ParticulierID || -1 } });
  return useQuery<Awaited<ReturnType<typeof promise>>, Error>(["offres_pe", { ParticulierID }], promise, {
    enabled: !!ParticulierID,
  });
};
